/** Recoverable capacity exhaustion; HostedRoot preserves the Scene and changes transport. */
export class MutationTransportBackpressureError extends Error {
    constructor(message) {
        super(message);
        this.name = "MutationTransportBackpressureError";
    }
}
//# sourceMappingURL=transport-errors.js.map